export enum ECallFlowType {
    QUEUE = 'queue',
    DIRECT_CALL = 'direct-call',
}

export enum EQueueDispatchMode {
    RING_ALL = 'ring-all',
    PRIORITY_ORDER = 'priority-order',
    CUSTOM_FLOW = 'custom-flow',
}